<template>
  <div class="em-block p-5-i mb-5-i">
    <h5 class="dark mb-0-i text-base-i">Export for</h5>
    <p class="mb-0-i text-base-i">{{title}}</p>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  })
</script>